import React, { useContext } from "react";
import style from "./index.module.scss";
import ExerciseStaticsOption from "../ExerciseStaticsOption";
import RightWrongCount from "../RigthWrongCount";
import { courseProjectionUrl } from "service/url";
import { BaseQuestionType, EndExerciseQuestion } from "service/exercise";
import { CourseContext } from "../../../Store";
import { isTrue } from "service/service";
import { indexToChar } from "utils/common";
import { useHistory } from "react-router-dom";

interface TopicDetailProps {
    index: number;
    data: EndExerciseQuestion;
    subQuestion?: boolean;
}

export default function TopicDetail({
    index,
    data,
    subQuestion = false
}: TopicDetailProps) {
    const history = useHistory();
    const { course } = useContext(CourseContext);

    function getRightOptions() {
        if (
            ![
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice,
                BaseQuestionType.Judge
            ].includes(data.queTypeId)
        )
            return;

        return (
            data.optionModelList
                ?.map((item, index) => ({
                    ...item,
                    char:
                        data.queTypeId === BaseQuestionType.Judge
                            ? item.description
                            : indexToChar(index)
                }))
                .filter(item => isTrue(item.isRight))
                .map(item => item.char)
                .join("") || ""
        );
    }

    return (
        <div className={style.root}>
            <div className={style.info}>
                {subQuestion ? <em>({index + 1}).</em> : <em>{index + 1}.</em>}
                （{data.queTypeName}，{data.score}分）
                {data.queTypeId < BaseQuestionType.Mixed && (
                    <span className={style.rate}>
                        {data.queTypeId === BaseQuestionType.Subjective
                            ? `暂不提供主观题的作答正确率`
                            : `正确率${data.accuracy}`}
                    </span>
                )}
            </div>

            <div
                className={style.trunk}
                dangerouslySetInnerHTML={{ __html: data.contentText }}
            />

            {[
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice
            ].includes(data.queTypeId) && (
                <div className={style.options}>
                    {data.optionModelList?.map((option, index) => (
                        <ExerciseStaticsOption
                            key={option.id}
                            queTypeId={data.queTypeId}
                            index={index}
                            data={option}
                        />
                    ))}
                </div>
            )}

            {[
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice,
                BaseQuestionType.Judge,
                BaseQuestionType.Fill
            ].includes(data.queTypeId) && (
                <RightWrongCount
                    rightList={data.stuRightList || []}
                    wrongList={data.stuUnRightList || []}
                />
            )}

            {[
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice,
                BaseQuestionType.Judge,
                BaseQuestionType.Fill
            ].includes(data.queTypeId) && (
                <div className={style.answer}>
                    <h1>
                        【正确答案】 <span>{getRightOptions()}</span>
                    </h1>

                    {data.queTypeId === BaseQuestionType.Fill &&
                        data.optionModelList.map((option, index) => (
                            <p key={option.id}>
                                填空{index + 1}：{option.description}
                            </p>
                        ))}
                </div>
            )}

            {data.queTypeId === BaseQuestionType.Subjective && (
                <div className={style.answerSuggested}>
                    <h1>
                        参考答案{" "}
                        <span className={style.answerTip}>
                            (活动结束后学生可见)
                        </span>
                    </h1>
                    <div dangerouslySetInnerHTML={{ __html: data.analysis }} />
                </div>
            )}

            {data.questionModelList?.map((question, index) => (
                <TopicDetail
                    key={question.id}
                    index={index}
                    data={question}
                    subQuestion
                />
            ))}

            {!subQuestion && (
                <button
                    className={style.cast}
                    onClick={() =>
                        history.push(
                            courseProjectionUrl(
                                course.weekTimeId,
                                `exercise/${data.paperId}#id=${data.id}`
                            )
                        )
                    }>
                    投屏讲解
                </button>
            )}
        </div>
    );
}
